type Props = {
  className?: string;
};
const OutLink = ({ className = '' }: Props) => (
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M81.436 14.564v54.285h-8V28.221L18.22 83.436l-5.656-5.656L67.78 22.563l-40.629.001v-8z"></path>
  </svg>
);

export default OutLink;
